import { Button, GlobalContext, Input, Table, Tbody, Td, Th, Thead, Tr } from 'lynkco-up-core';
import { useContext, useEffect, useState } from 'react';
import { EditMarketInfo, GetMarketInfo, getCountryByCode } from '../../services/bookings/types';
import editMarket from '../../services/markets/editMarkets';
import { PageHeading } from '../../components';
import { handleAction } from '../HistoryLog/historyLogService';
import { ActionStatus } from '../HistoryLog/types';
import { durations } from '../../parts/shared/utils';
import { getMarkets } from '../../services/markets/getMarkets';

const ServiceFees = () => {
  const { alert } = useContext(GlobalContext);
  async function fetchMarketInfos() {
    try {
      const fetchedMarketInfos: GetMarketInfo[] = await getMarkets();
      setMarkets(fetchedMarketInfos);
      setOldMarkets(fetchedMarketInfos);
    } catch (error) {
      alert.show('Failed to fetch markets:', 'error');
    }
  }
  const [selectedPriceLevel] = useState('FEE_PRICE_LEVEL_2');
  const [markets, setMarkets] = useState<GetMarketInfo[]>([]);
  const [oldMarkets, setOldMarkets] = useState<GetMarketInfo[]>([]);
  useEffect(() => {
    fetchMarketInfos();
  }, []);
  // This is commented until we implement different price levels in the market
  // const handlePriceLevelChange = (event: any) => {
  //   setSelectedPriceLevel(event.target.checked ? 'FEE_PRICE_LEVEL_2' : 'FEE_PRICE_LEVEL_1');
  // };

  const submitFeeChange = () => {
    for (let i = 0; i < markets.length; i++) {
      const market = markets[i];
      const oldMarket = oldMarkets[i];
      if (market.isChanged) {
        const editModel: EditMarketInfo = {
          fuel: market.fuelPerLiter,
          electricPerKwh: market.electricPerKwh,
          buffer: market.buffer,
          currency: market.currency,
          maxCostLimitPerBooking: market.maxCostLimitPerBooking,
          vat: market.vat,
          serviceFees: market.serviceFees,
        };
        editMarket(editModel, market.market)
          .then(() => {
            handleAction(ActionStatus.MODIFYING_SERVICE_FEE, [
              { market: market.market },
              { newValue: editModel.serviceFees },
              { oldValue: oldMarket.serviceFees },
            ]);
            alert.show('Successfully updated market', 'success');
          })
          .catch(() => {
            alert.show('Unable to update market', 'error');
          });
      }
    }
    fetchMarketInfos();
  };

  const renderTableHeader = () => {
    return (
      <Thead>
        <Tr>
          <Th>
            {' '}
            <span>Country</span>
          </Th>
          <Th>
            {' '}
            <span>Currency</span>
          </Th>
          <>
            {durations.map(duration => (
              <Th key={duration.durationKey} extraClasses="mx-auto">
                <span>{duration.title}</span>
              </Th>
            ))}
          </>
        </Tr>
      </Thead>
    );
  };

  const renderTableBody = () => {
    return (
      <Tbody>
        {markets?.map(item => (
          <Tr key={item.market}>
            <Td extraClasses="px-4 py-2 font-bold">{getCountryByCode(item.market)}</Td>
            <Td>
              <span className="font-light">{item.currency}</span>
            </Td>

            <>
              {durations.map(duration => {
                const fee = item.serviceFees.find(
                  fee => fee.duration === duration.durationKey && fee.priceLevel === selectedPriceLevel,
                );
                return (
                  <Td key={duration.durationKey}>
                    <div className="flex items-center">
                      <Input
                        type="number"
                        value={fee ? fee.fee : ''}
                        onChange={e => handleFeeChange(item.market, duration.durationKey, e.currentTarget.value)}
                      />
                    </div>
                  </Td>
                );
              })}
            </>
          </Tr>
        ))}
      </Tbody>
    );
  };

  const handleFeeChange = (market: string, duration: string, newFee: string) => {
    const updatedData = markets.map(item => {
      if (item.market === market) {
        const updatedFees = item.serviceFees.map(fee => {
          if (fee.duration === duration && fee.priceLevel === selectedPriceLevel) {
            item.isChanged = true;
            return { ...fee, fee: parseFloat(newFee) };
          }
          return fee;
        });
        return { ...item, serviceFees: updatedFees };
      }
      return item;
    });
    setMarkets(updatedData);
  };

  return (
    <div className="min-h-screen">
      <PageHeading
        title="Service Fees (Excluding VAT)"
        description="A list of country, durations with service fees list."></PageHeading>
      <Table extraClasses="min-w-max">
        {renderTableHeader()}
        {renderTableBody()}
      </Table>
      <Button
        onClick={submitFeeChange}
        variant="primary"
        extraClasses="mt-4 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500">
        Submit
      </Button>
    </div>
  );
};

export default ServiceFees;
